/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_DAILY_REPORTS, GET_DAILY_REPORTS } from 'src/actions/dailyReportActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const dailyReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DAILY_REPORTS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_DAILY_REPORTS: {
      const { dailyReports, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = dailyReports;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default dailyReportReducer;
